import { Controller } from 'stimulus';

export default class FlashController extends Controller {
  dismiss() {
    document.querySelector('#flash-container').remove();
  }
}
